import { Title } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import styles from "./DismissModal.module.scss"

export const IncidentDismissInfo = ({
  count,
  entityType
}: {
  count: number
  entityType: string
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Title className={styles.title} level={4}>
        {t("triage.dismiss_modal.title", { count, entityType })}
      </Title>
    </>
  )
}
